import { Schema as S } from "effect";

export const ListTenantsResponseSchema = S.Array(S.Unknown);

export type ListTenantsResponse = S.Schema.Type<typeof ListTenantsResponseSchema>;
